module.exports = __webpack_public_path__ + "static/media/gamesPlayed_10000_50000.83a2d36d.png";